import { render } from "./Records.vue?vue&type=template&id=610cd22e&scoped=true&ts=true"
import script from "./Records.vue?vue&type=script&lang=ts"
export * from "./Records.vue?vue&type=script&lang=ts"

import "./Records.vue?vue&type=style&index=0&id=610cd22e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610cd22e"]])

export default __exports__